import { NgModule } from '@angular/core';

import { SbbRadioGroup } from './radio-group.directive';

@NgModule({
  declarations: [SbbRadioGroup],
  exports: [SbbRadioGroup],
})
export class SbbRadioButtonModule {}
